import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const useFrequentlyBoughtTogethers = (entityId, type, forcedFetch = false) => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['frequentlyBoughtTogether', JSON.stringify({ entityId, type })],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/dealer-portal/frequently-bought-togethers/${entityId}/${type}`);
      return response.data;
    },
    enabled: !!entityId,
    throwOnError: errorMessage,
    staleTime: forcedFetch ? 0 : Infinity,
  });
  return query;
};
